function PhoneMockups() {
  return (
    <div className="phone-stage" aria-hidden="true">
      <div className="phone-glow" />

      <div className="phone phone--growth">
        <div className="phone__bezel">
          <div className="phone__notch" />
          <img
            src={`${process.env.PUBLIC_URL}/images/growth-tree-hero.jpg`}
            alt=""
            className="phone__screen-img"
          />
        </div>
      </div>

      <div className="phone phone--sanctuary">
        <div className="phone__bezel phone__bezel--light">
          <div className="phone__notch phone__notch--light" />
          <div className="phone__screen phone__screen--cream">
            <span className="sanc-label">Sanctuary</span>
            <h4 className="sanc-title">Psalm 23</h4>
            <p className="sanc-meta">ESV · Quiet Mode</p>
            <div className="sanc-body">
              <p>
                The Lord is my shepherd; I shall not want. He makes me lie down
                in green pastures. He leads me beside still waters. He restores
                my soul.
              </p>
              <p>
                He leads me in paths of righteousness for his name’s sake. Even
                though I walk through the valley of the shadow of death, I will
                fear no evil…
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PhoneMockups;
